module.exports = __webpack_public_path__ + "img/wechat.4346e8ef.png";